/* Lasclay : configurateur de produits personnalisés + formulaire de soumission.
   Vanilla JS, aucune dépendance. Aperçu 2D : le logo du client est posé sur la photo studio du
   produit, n'importe où sur sa silhouette, avec un rendu propre à chaque technique (broderie,
   étiquette, écusson, impression, gravure). Traitement d'image : lasclay-perso-image.js. */
(function () {
  'use strict';

  var LOGO_MAX = 10 * 1024 * 1024;
  var APERCU_OK = /^image\/(png|jpeg|svg\+xml|webp)$/;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, attrs, texte) {
    var e = document.createElement(tag);
    for (var k in attrs || {}) { if (attrs[k] !== null && attrs[k] !== undefined) e.setAttribute(k, attrs[k]); }
    if (texte !== undefined) e.textContent = texte;
    return e;
  }
  function paliers(texte) { // "100:5,250:10" -> [{q:100, v:5}, ...] trié
    return String(texte || '').split(/[,;\n]/).map(function (s) {
      var m = s.split(':'); return { q: parseInt(m[0], 10), v: parseFloat(String(m[1] || '').replace(',', '.')) };
    }).filter(function (x) { return x.q > 0 && !isNaN(x.v); }).sort(function (a, b) { return a.q - b.q; });
  }
  function auPalier(liste, q) { var v = 0; liste.forEach(function (x) { if (q >= x.q) v = x.v; }); return v; }

  // État partagé avec le formulaire de soumission (même page ou page dédiée).
  // `touche` : le client a réellement configuré quelque chose. Tant que non, rien du configurateur
  // ne suit la demande, sinon le choix par défaut (1er produit, 1re couleur) passe pour son choix.
  var partage = window.LasclayPerso = window.LasclayPerso || { config: null, logo: null, maquette: null, touche: false, ecouteurs: [] };
  function publier() { partage.ecouteurs.forEach(function (f) { try { f(partage); } catch (e) {} }); }

  /* ================================================================
     Configurateur
     ================================================================ */
  // Le logo se pose n'importe où sur le produit (silhouette détectée sur la photo), se déplace, se
  // redimensionne par les coins, se tourne et se pince à deux doigts. Son rendu (broderie, étiquette,
  // écusson, impression, gravure) est dessiné sur un calque par lasclay-perso-image.js.
  function initPerso(sec) {
    if (sec.__lvPerso) return; sec.__lvPerso = true;
    var data;
    try { data = JSON.parse($('[data-lv-perso-data]', sec).textContent); } catch (e) { return; }
    if (!data.produits || !data.produits.length) return;
    var LI = window.LasclayImage || null;
    var en = data.langue === 'en';
    var T = en
      ? { min: 'Minimum order: {n} units per design.', nonApercu: 'Preview not available for this format. Our team will prepare the proof from your file.', trop: 'File too large (10 MB max).', copie: 'Link copied', ajout: 'Add your logo to see it here',
          fondRetire: 'Background removed from your logo.', fondGarde: 'Logo background kept.', garderFond: 'Keep the background', retirerFond: 'Remove the background',
          contraste: 'Your logo barely shows on this colour.', blanc: 'Try it in white', noir: 'Try it in black',
          mbFait: 'Preview without the Lasclay logo. We confirm in the quote what is possible for this product.', mbRien: 'No Lasclay logo shows on this photo.', mbCalcul: 'Removing the Lasclay logo from the preview…',
          volume: 'Volume savings: {r} % ({m} less per unit).', volumeCible: 'At {q} units: {r} % off, that is {p} per unit.', volumeMax: 'Best price reached: {r} % off from {q} units.', volumeAucune: 'The unit price goes down as quantity goes up: up to {r} % off from {q} units.',
          iaCours: 'Generating the preview (about 20 seconds)…', iaLimite: 'AI preview limit reached for today. Request your quote: we will send you a proof.', iaRobot: 'The anti-robot check did not go through. Please try again in a moment.', iaIndispo: 'The AI preview is not available right now.', iaMax: 'You have used all the AI previews for this visit.' }
      : { min: 'Minimum de commande : {n} unités par modèle.', nonApercu: "Aperçu non disponible pour ce format. L'équipe préparera l'épreuve à partir de votre fichier.", trop: 'Fichier trop lourd (10 Mo maximum).', copie: 'Lien copié', ajout: 'Ajoutez votre logo pour le voir ici',
          fondRetire: 'Fond du logo retiré automatiquement.', fondGarde: 'Fond du logo conservé.', garderFond: 'Garder le fond', retirerFond: 'Retirer le fond',
          contraste: 'Votre logo ressort peu sur cette couleur.', blanc: 'Essayer en blanc', noir: 'Essayer en noir',
          mbFait: "Aperçu sans le logo Lasclay. Nous confirmons dans la soumission ce qui est possible pour ce produit.", mbRien: 'Aucun logo Lasclay ne paraît sur cette photo.', mbCalcul: "Retrait du logo Lasclay de l'aperçu…",
          volume: 'Économie de volume : {r} % ({m} de moins par unité).', volumeCible: 'À {q} unités : {r} % de moins, soit {p} l’unité.', volumeMax: 'Meilleur prix atteint : {r} % de moins dès {q} unités.', volumeAucune: 'Le prix par unité baisse avec la quantité : jusqu’à {r} % de moins dès {q} unités.',
          iaCours: "Génération de l'aperçu (environ 20 secondes)…", iaLimite: "Limite d'aperçus IA atteinte pour aujourd'hui. Demandez votre soumission : nous vous enverrons une épreuve.", iaRobot: "La vérification anti-robot n'a pas abouti. Réessayez dans un instant.", iaIndispo: "L'aperçu IA n'est pas disponible pour le moment.", iaMax: 'Vous avez utilisé tous les aperçus IA de cette visite.' };
    var argent = new Intl.NumberFormat(en ? 'en-CA' : 'fr-CA', { style: 'currency', currency: data.devise || 'CAD' });
    var fmt = function (cents) { return argent.format(cents / 100); };
    var hex = {};
    String(data.pastilles || '').split('\n').forEach(function (l) { var i = l.indexOf('='); if (i > 0) hex[l.slice(0, i).trim().toLowerCase()] = l.slice(i + 1).trim(); });
    var remises = paliers(data.remises);
    function liste(t) { return String(t || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(Boolean); }
    // minimum et paliers : ceux du produit s'il en a (ex. manteaux), sinon ceux de la section
    function minimumDe(p) { return p && p.minimum > 0 ? p.minimum : (data.minimum || 20); }
    function quantitesDe(p) { var l = liste(p && p.quantites); return l.length ? l : liste(data.quantites); }
    function borne(v, a, b) { return v < a ? a : v > b ? b : v; }

    // Pose du logo en fractions de la photo : centre (cx, cy), largeur du logo (lw), rotation (r, degrés).
    // lw = null : pas encore posé, il ira à l'emplacement suggéré du produit.
    var etat = { p: 0, c: 0, t: null, q: null, lw: null, cx: 0.5, cy: 0.5, r: 0, te: 'originale', lasclay: true, fond: false };
    var logoFichier = null, logoApercu = false, prepa = null, versionLogo = 0;

    var img = $('[data-produit-img]', sec), scene = $('[data-scene]', sec), calque = $('[data-calque]', sec), zone = $('[data-zone]', sec);
    var toile = $('[data-toile]', sec), cadre = $('[data-cadre]', sec), aide = $('[data-zone-aide]', sec), outils = $('[data-outils]', sec);
    var astuce = $('[data-astuce]', sec), calcul = $('[data-calcul]', sec), contraste = $('[data-contraste]', sec);
    var caseMB = $('[data-marque-blanche]', sec), noteMB = $('[data-mb-note]', sec), blocFond = $('[data-fond-logo]', sec);

    // --- restauration : lien partagé (#personnaliser=...) ou dernière session
    try {
      var h = decodeURIComponent(location.hash || '');
      var m = h.match(/perso=(\{.*\})/);
      var sauve = m ? JSON.parse(m[1]) : JSON.parse(localStorage.getItem('lv-perso') || 'null');
      if (sauve) {
        var ip = data.produits.map(function (p) { return p.handle; }).indexOf(sauve.p);
        if (ip >= 0) {
          etat.p = ip;
          ['c', 't', 'q', 'te', 'lasclay', 'fond'].forEach(function (k) { if (sauve[k] !== undefined) etat[k] = sauve[k]; });
          // la pose n'a de sens que dans le format actuel (v2 : fractions de la photo)
          if (sauve.v === 2) ['lw', 'cx', 'cy', 'r'].forEach(function (k) { if (sauve[k] !== undefined) etat[k] = sauve[k]; });
          if (m || sauve.touche) partage.touche = true; // lien partagé, ou modèle configuré lors d'une visite précédente
        }
      }
    } catch (e) {}

    // Tout geste du client dans le configurateur compte comme une configuration. Écouté en capture,
    // donc avant les gestionnaires qui appellent memoriser() : le geste est enregistré avec le modèle.
    function toucher() { partage.touche = true; }
    ['change', 'input', 'drop'].forEach(function (ev) { sec.addEventListener(ev, toucher, true); });
    sec.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('button')) toucher(); }, true);

    function produit() { return data.produits[etat.p]; }
    if (!etat.q) etat.q = quantitesDe(produit())[0] || minimumDe(produit());
    // prix corporatif = pourcentage du prix affiché sur le site (lu à l'affichage de la page)
    function prixCorpo(p) { return Math.round(p.prix * (data.pourcentage || 60) / 100); }
    // Remise de volume (%) : progressive et proportionnelle, de 0 % au minimum de commande jusqu'au
    // maximum à remiseQte unités (20 % dès 300 par défaut). Des paliers fixes, s'il y en a, la remplacent.
    var remiseQte = data.remiseQte > 0 ? data.remiseQte : 300;
    function remiseDe(q, p) {
      if (remises.length) return auPalier(remises, q);
      var max = data.remiseMax || 0, min = minimumDe(p || produit());
      if (max <= 0 || q <= min) return 0;
      return Math.round(max * Math.min(1, (q - min) / Math.max(1, remiseQte - min)));
    }
    function remiseMaximale() { return remises.length ? remises[remises.length - 1].v : (data.remiseMax || 0); }
    function qteMaximale() { return remises.length ? remises[remises.length - 1].q : remiseQte; }
    function prixAvant() {
      var sup = etat.t && data.techniques[etat.t] ? data.techniques[etat.t].sup : 0;
      if (!etat.lasclay) sup += data.supMarqueBlanche || 0;
      return prixCorpo(produit()) + sup;
    }
    function prixA(q) { return Math.max(0, Math.round(prixAvant() * (1 - remiseDe(q) / 100))); }
    function prixUnitaire() { return prixA(etat.q); }
    // « dès » : le meilleur prix, celui de la remise maximale
    function aPartirDe(p) { return Math.round(prixCorpo(p) * (1 - remiseDe(Math.max(qteMaximale(), minimumDe(p)), p) / 100)); }

    // --- 1. produits
    var boxProduits = $('[data-produits]', sec);
    data.produits.forEach(function (p, i) {
      var lab = el('label', { class: 'lvc-carte-produit' });
      var inp = el('input', { type: 'radio', name: 'lv-produit-' + sec.id, value: i });
      if (i === etat.p) inp.checked = true;
      inp.addEventListener('change', function () {
        etat.p = i; etat.c = 0; etat.t = null; etat.lw = null;
        if (etat.q < minimumDe(p)) { etat.q = quantitesDe(p)[0] || minimumDe(p); champQ.value = ''; }
        construireQuantites(); rendre();
      });
      var im = el('img', { src: p.vignette, alt: '', loading: 'lazy', width: 200, height: 250 });
      var nom = el('span', { class: 'lvc-carte-produit__nom' }, p.titre);
      var prix = el('span', { class: 'lvc-carte-produit__prix' }, data.afficherPrix ? (en ? 'from ' : 'dès ') + fmt(aPartirDe(p)) : '');
      lab.appendChild(inp); lab.appendChild(im); lab.appendChild(nom); lab.appendChild(prix);
      boxProduits.appendChild(lab);
    });

    /* ---------- photo du produit : silhouette, version sans logo Lasclay, éclairage ---------- */
    var photos = {};      // photo d'origine -> { pret, im, sil, propre (url sans Lasclay, null si rien) }
    var eclairages = {};  // photo affichée -> carte d'ombrage
    function chargerImage(src) {
      return new Promise(function (ok) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { ok(i); }; i.onerror = function () { ok(null); }; i.src = src; });
    }
    function photo(u) {
      var P = photos[u] || (photos[u] = {});
      if (!P.pret) P.pret = chargerImage(u).then(function (im) { P.im = im; try { P.sil = im && LI ? LI.silhouette(im) : null; } catch (e) { P.sil = null; } return P; });
      return P;
    }
    function urlOrigine() { var c = produit().couleurs[etat.c]; return c ? c.image : ''; }
    function photoCourante() { return photos[urlOrigine()] || null; }
    function aEffacer(p) { var z = p.lasclay; return !!(LI && z && z.w > 0 && z.h > 0); }
    function eclairage() { return eclairages[img.currentSrc || img.src] || null; }
    var jeton = 0;
    function majPhoto() {
      var u = urlOrigine(), P = photo(u), p = produit(), mon = ++jeton;
      function afficher(src) { if (mon !== jeton) return; if (img.getAttribute('src') !== src) img.src = src; else apresPhoto(); }
      img.alt = p.titre + (p.couleurs[etat.c] && p.couleurs[etat.c].nom ? ' · ' + p.couleurs[etat.c].nom : '');
      majNoteMB();
      if (etat.lasclay || !aEffacer(p)) { calcul.hidden = true; afficher(u); return; }
      if (P.propre !== undefined) { afficher(P.propre || u); return; }
      afficher(u); calcul.hidden = false;
      P.pret.then(function () {
        if (!P.im) return null;
        return P.efface || (P.efface = LI.sansLasclay(P.im, p.lasclay, P.sil));
      }).then(function (r) {
        P.propre = r ? r.url : null;
        if (mon !== jeton) return;
        calcul.hidden = true; majNoteMB();
        if (!etat.lasclay) afficher(P.propre || u);
      });
    }
    function majNoteMB() {
      var P = photos[urlOrigine()];
      noteMB.hidden = etat.lasclay;
      if (etat.lasclay) return;
      noteMB.textContent = !aEffacer(produit()) ? T.mbRien : (!P || P.propre === undefined ? T.mbCalcul : (P.propre ? T.mbFait : T.mbRien));
    }
    function apresPhoto() {
      var P = photo(urlOrigine()), src = img.currentSrc || img.src;
      P.pret.then(function () {
        if (LI && eclairages[src] === undefined) { try { eclairages[src] = LI.eclairage(img, P.sil); } catch (e) { eclairages[src] = null; } }
        geometrie(); if (etat.lw === null) suggerer(); bornes(); dessiner(); memoriser();
      });
    }
    img.addEventListener('load', apresPhoto);

    // Le calque couvre exactement la photo, affichée en « contain » dans la scène 4:5.
    var geo = { iw: 0, ih: 0, nw: 0, nh: 0 };
    function geometrie() {
      var W = scene.clientWidth, H = scene.clientHeight, nw = img.naturalWidth, nh = img.naturalHeight;
      if (!W || !H || !nw || !nh) return false;
      var k = Math.min(W / nw, H / nh), iw = nw * k, ih = nh * k;
      calque.style.left = (W - iw) / 2 + 'px'; calque.style.top = (H - ih) / 2 + 'px';
      calque.style.width = iw + 'px'; calque.style.height = ih + 'px';
      geo = { iw: iw, ih: ih, nw: nw, nh: nh };
      var dpr = Math.min(2, window.devicePixelRatio || 1), tw = Math.round(iw * dpr), th = Math.round(ih * dpr);
      if (toile.width !== tw || toile.height !== th) { toile.width = tw; toile.height = th; cacheToile = {}; }
      var z = produit().zone;
      zone.style.left = z.x + '%'; zone.style.top = z.y + '%'; zone.style.width = z.w + '%'; zone.style.height = z.h + '%';
      zone.style.transform = z.r ? 'rotate(' + z.r + 'deg)' : '';
      return true;
    }
    if (window.ResizeObserver) new ResizeObserver(function () { if (geometrie()) dessiner(); }).observe(scene);
    else window.addEventListener('resize', function () { if (geometrie()) dessiner(); });

    /* ---------- logo : pose et bornes ---------- */
    function logoActif() { return prepa ? (etat.fond ? prepa.avec : prepa.sans) : null; }
    function boite() { var P = photoCourante(); return P && P.sil ? P.sil.boite : { x: 0, y: 0, w: 1, h: 1 }; }
    // l'objet posé (logo, étiquette ou écusson), en fractions de la photo
    function objet() {
      var L = logoActif();
      if (!L || !LI || !geo.nw || etat.lw === null) return null;
      var g = LI.geometrie(etat.t, etat.lw * geo.nw, L.ratio);
      return { w: g.ow / geo.nw, h: g.oh / geo.nh };
    }
    function suggerer() {
      var z = produit().zone, L = logoActif();
      etat.cx = (z.x + z.w / 2) / 100; etat.cy = (z.y + z.h / 2) / 100; etat.r = z.r || 0;
      if (!L || !LI || !geo.nw) { etat.lw = null; return; }
      var g = LI.geometrie(etat.t, 100, L.ratio);
      var k = Math.min(z.w / 100 * geo.nw * 0.85 / g.ow, z.h / 100 * geo.nh * 0.85 / g.oh);
      etat.lw = 100 * k / geo.nw;
      bornes();
    }
    // taille entre 3 % de la photo et la taille du produit ; centre sur le produit
    function bornes() {
      var o = objet(); if (!o) return;
      var b = boite(), k = 1;
      if (o.w > b.w) k = b.w / o.w;
      if (o.h * k > b.h) k = b.h / o.h;
      if (o.w * k < 0.03) k = 0.03 / o.w;
      etat.lw *= k;
      etat.cx = borne(etat.cx, b.x, b.x + b.w); etat.cy = borne(etat.cy, b.y, b.y + b.h);
      etat.r = ((etat.r + 540) % 360) - 180;
    }

    /* ---------- rendu sur le calque ---------- */
    var cacheToile = {}, minuterie = null, attente = false;
    // Peint le logo sur un canevas qui représente toute la photo (W x H px). rapide : pendant un geste,
    // on réutilise le rendu précédent mis à l'échelle ; le vrai rendu suit dès que le geste s'arrête.
    function peindre(cx, W, H, rapide, cache) {
      var L = logoActif(); if (!L || !LI || etat.lw === null) return null;
      var largeur = etat.lw * W;
      var cle = [versionLogo, etat.fond, etat.t, etat.te, Math.round(largeur), W].join('|'), echelle = 1;
      if (!cache.s || (cache.cle !== cle && !rapide)) {
        cache.s = LI.rendre(L, { technique: etat.t, teinte: etat.te, largeur: largeur, point: Math.max(1.6, W * 0.0045) });
        cache.cle = cle; cache.largeur = largeur;
      } else if (cache.cle !== cle) echelle = largeur / cache.largeur;
      var S = cache.s;
      cx.save(); cx.translate(etat.cx * W, etat.cy * H); cx.rotate(etat.r * Math.PI / 180); cx.scale(echelle, echelle);
      cx.drawImage(S.cv, -S.x - S.w / 2, -S.y - S.h / 2); cx.restore();
      var e = eclairage(), P = photoCourante(), d = Math.hypot(S.cv.width, S.cv.height) * echelle / 2 + 2;
      if (e && etat.t !== 'gravure') LI.eclairer(cx, e, etat.cx * W - d, etat.cy * H - d, 2 * d, 2 * d, 0, 0, W, H, etat.t === 'impression');
      if (P && P.sil) { cx.globalCompositeOperation = 'destination-in'; cx.drawImage(P.sil.cv, 0, 0, W, H); cx.globalCompositeOperation = 'source-over'; }
      return S;
    }
    function dessiner(rapide) {
      var cx = toile.getContext('2d', { willReadFrequently: true });
      cx.clearRect(0, 0, toile.width, toile.height);
      var o = objet(), vu = !!(logoApercu && o);
      cadre.hidden = !vu; astuce.hidden = !vu; outils.hidden = !vu;
      if (boxIA) boxIA.hidden = !vu;
      zone.hidden = vu || !geo.nw;
      aide.textContent = logoFichier && !logoApercu ? T.nonApercu : T.ajout;
      toile.style.mixBlendMode = etat.t === 'gravure' ? 'multiply' : 'normal';
      if (!vu) { contraste.hidden = true; return; }
      try { peindre(cx, toile.width, toile.height, rapide, cacheToile); } catch (e) {}
      cadre.style.left = etat.cx * 100 + '%'; cadre.style.top = etat.cy * 100 + '%';
      cadre.style.width = o.w * 100 + '%'; cadre.style.height = o.h * 100 + '%';
      cadre.style.transform = 'translate(-50%, -50%) rotate(' + etat.r + 'deg)';
      cadre.classList.toggle('is-petit', Math.min(o.w * geo.iw, o.h * geo.ih) < 56);   // poignées discrètes sur un petit logo
      taille.value = Math.round(o.w / boite().w * 100);
      if (rapide) { clearTimeout(minuterie); minuterie = setTimeout(function () { dessiner(false); }, 180); }
      else majContraste();
    }
    function planifier() {
      if (attente) return; attente = true;
      requestAnimationFrame(function () { attente = false; dessiner(true); });
    }
    // Logo de la même clarté que le tissu (logo noir brodé sur un sac noir) : on propose l'inverse.
    function majContraste() {
      var L = logoActif(), e = eclairage();
      if (!L || !e || (etat.t !== 'broderie' && etat.t !== 'impression')) { contraste.hidden = true; return; }
      var s = LI.couleurSous(e, etat.cx, etat.cy, 0.03), ls = s[0] * 0.299 + s[1] * 0.587 + s[2] * 0.114;
      var ll = etat.te === 'blanc' ? 240 : etat.te === 'noir' ? 26 : L.lum, cible = ls < 128 ? 'blanc' : 'noir';
      contraste.hidden = Math.abs(ll - ls) >= 60 || etat.te === cible;
      if (contraste.hidden) return;
      $('[data-contraste-texte]', contraste).textContent = T.contraste;
      var b = $('[data-contraste-btn]', contraste); b.textContent = T[cible]; b.setAttribute('data-v', cible);
    }
    $('[data-contraste-btn]', sec).addEventListener('click', function (e) { etat.te = e.currentTarget.getAttribute('data-v'); rendre(); });

    /* ---------- gestes : déplacer, redimensionner, tourner, pincer ---------- */
    var geste = null, pointeurs = {};
    function versCalque(e) { var r = calque.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top, w: r.width || 1, h: r.height || 1 }; }
    function rot(a, x, y) { return { x: x * Math.cos(a) - y * Math.sin(a), y: x * Math.sin(a) + y * Math.cos(a) }; }
    cadre.addEventListener('pointerdown', function (e) {
      var o = objet(); if (!o) return;
      e.preventDefault();
      try { cadre.focus({ preventScroll: true }); cadre.setPointerCapture(e.pointerId); } catch (x) {}
      var p = versCalque(e); pointeurs[e.pointerId] = p;
      var ids = Object.keys(pointeurs), a = etat.r * Math.PI / 180;
      var C = { x: etat.cx * p.w, y: etat.cy * p.h }, ow = o.w * p.w, oh = o.h * p.h;
      var poignee = e.target && e.target.getAttribute ? e.target.getAttribute('data-poignee') : null;
      if (ids.length >= 2) {
        var q = pointeurs[ids[0]], s = pointeurs[ids[1]];
        geste = { type: 'pince', d0: Math.hypot(q.x - s.x, q.y - s.y), a0: Math.atan2(s.y - q.y, s.x - q.x), lw: etat.lw, r: etat.r };
      } else if (poignee === 'rot') {
        geste = { type: 'tourne', C: C };
      } else if (poignee) {
        // coin opposé fixe, proportions gardées
        var sx = poignee.indexOf('e') >= 0 ? 1 : -1, sy = poignee.indexOf('s') >= 0 ? 1 : -1, v = rot(a, -sx * ow / 2, -sy * oh / 2);
        geste = { type: 'taille', O: { x: C.x + v.x, y: C.y + v.y }, sx: sx, sy: sy, a: a, ow: ow, oh: oh, lw: etat.lw };
      } else {
        geste = { type: 'deplace', x: p.x, y: p.y, cx: etat.cx, cy: etat.cy };
      }
      cadre.classList.add('is-actif');
    });
    cadre.addEventListener('pointermove', function (e) {
      if (!geste || !pointeurs[e.pointerId]) return;
      var p = versCalque(e); pointeurs[e.pointerId] = p;
      if (geste.type === 'deplace') {
        etat.cx = geste.cx + (p.x - geste.x) / p.w; etat.cy = geste.cy + (p.y - geste.y) / p.h;
      } else if (geste.type === 'tourne') {
        var ang = Math.atan2(p.y - geste.C.y, p.x - geste.C.x) * 180 / Math.PI + 90;
        var droit = Math.round(ang / (e.shiftKey ? 15 : 45)) * (e.shiftKey ? 15 : 45);
        if (e.shiftKey || Math.abs(ang - droit) < 4) ang = droit;   // aimanté à l'horizontale et aux 45°
        etat.r = ang;
      } else if (geste.type === 'taille') {
        var l = rot(-geste.a, p.x - geste.O.x, p.y - geste.O.y);
        var ow2 = Math.max(l.x * geste.sx, l.y * geste.sy * geste.ow / geste.oh, 8), k = ow2 / geste.ow;
        var v = rot(geste.a, geste.sx * ow2 / 2, geste.sy * geste.oh * k / 2);
        etat.lw = geste.lw * k; etat.cx = (geste.O.x + v.x) / p.w; etat.cy = (geste.O.y + v.y) / p.h;
      } else if (geste.type === 'pince') {
        var ids = Object.keys(pointeurs); if (ids.length < 2) return;
        var q = pointeurs[ids[0]], s = pointeurs[ids[1]];
        etat.lw = geste.lw * Math.hypot(q.x - s.x, q.y - s.y) / Math.max(1, geste.d0);
        etat.r = geste.r + (Math.atan2(s.y - q.y, s.x - q.x) - geste.a0) * 180 / Math.PI;
      }
      bornes(); planifier();
    });
    function finGeste(e) {
      delete pointeurs[e.pointerId];
      if (!geste) return;
      if (geste.type === 'pince' && Object.keys(pointeurs).length) { geste = null; return; }
      geste = null; cadre.classList.remove('is-actif');
      toucher(); clearTimeout(minuterie); dessiner(false); memoriser();
    }
    ['pointerup', 'pointercancel'].forEach(function (ev) { cadre.addEventListener(ev, finGeste); });
    cadre.addEventListener('keydown', function (e) {
      if (!objet()) return;
      var pas = e.shiftKey ? 0.02 : 0.005, k = e.key;
      if (k === 'ArrowLeft') etat.cx -= pas; else if (k === 'ArrowRight') etat.cx += pas;
      else if (k === 'ArrowUp') etat.cy -= pas; else if (k === 'ArrowDown') etat.cy += pas;
      else if (k === '+' || k === '=') etat.lw *= 1.05; else if (k === '-' || k === '_') etat.lw /= 1.05;
      else if (k === ']') etat.r += e.shiftKey ? 15 : 3; else if (k === '[') etat.r -= e.shiftKey ? 15 : 3;
      else return;
      e.preventDefault(); toucher(); bornes(); dessiner(false); memoriser();
    });

    // --- 5. quantités
    var boxQ = $('[data-quantites]', sec), champQ = $('[data-quantite]', sec);
    function construireQuantites() {
      boxQ.innerHTML = '';
      quantitesDe(produit()).forEach(function (q) {
        var b = el('button', { type: 'button', 'data-q': q }, String(q));
        var r = remiseDe(q);
        if (r > 0) b.appendChild(el('small', { class: 'lvc-quantites__remise' }, '−' + r + ' %'));
        b.addEventListener('click', function () { etat.q = q; champQ.value = ''; rendre(); });
        boxQ.appendChild(b);
      });
    }
    construireQuantites();
    champQ.addEventListener('input', function () { var v = parseInt(champQ.value, 10); if (v > 0) { etat.q = v; rendre(); } });

    // --- 4. logo : détourage automatique (fond uni retiré), recadrage
    var champF = $('[data-fichier]', sec), nomF = $('[data-fichier-nom]', sec), depot = $('[data-depot]', sec);
    function ouvrirLogo(f) {
      return new Promise(function (ok) {
        function charger(u) { var i = new Image(); i.onload = function () { ok(i); URL.revokeObjectURL(u); }; i.onerror = function () { ok(null); URL.revokeObjectURL(u); }; i.src = u; }
        if (f.type !== 'image/svg+xml') return charger(URL.createObjectURL(f));
        // SVG sans dimensions : on lui en donne, d'après son viewBox, pour le dessiner net
        f.text().then(function (t) {
          var m = t.match(/<svg[^>]*>/i); if (!m) return ok(null);
          var vb = m[0].match(/viewBox\s*=\s*["']\s*[-\d.]+[\s,]+[-\d.]+[\s,]+([\d.]+)[\s,]+([\d.]+)/i);
          var r = vb ? parseFloat(vb[1]) / parseFloat(vb[2]) : 1;
          var tag = m[0].replace(/\s(width|height)\s*=\s*["'][^"']*["']/gi, '').replace(/<svg/i, '<svg width="1200" height="' + Math.round(1200 / (r || 1)) + '"');
          charger(URL.createObjectURL(new Blob([t.replace(m[0], tag)], { type: 'image/svg+xml' })));
        }, function () { ok(null); });
      });
    }
    function lireFichier(f) {
      if (!f) return;
      if (f.size > LOGO_MAX) { nomF.hidden = false; nomF.textContent = T.trop; return; }
      logoFichier = f; logoApercu = !!LI && APERCU_OK.test(f.type); prepa = null; versionLogo++;
      nomF.hidden = false; nomF.textContent = f.name + (logoApercu ? '' : ' · ' + T.nonApercu);
      if (!logoApercu) { rendre(); return; }
      ouvrirLogo(f).then(function (im) {
        if (logoFichier !== f) return;
        try { prepa = im ? LI.preparerLogo(im) : null; } catch (e) { prepa = null; }
        if (!prepa) { logoApercu = false; nomF.textContent = f.name + ' · ' + T.nonApercu; }
        else if (etat.lw === null) suggerer();
        versionLogo++; rendre();
      });
    }
    champF.addEventListener('change', function () { lireFichier(champF.files[0]); });
    ['dragover', 'dragenter'].forEach(function (ev) { depot.addEventListener(ev, function (e) { e.preventDefault(); depot.classList.add('is-survol'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { depot.addEventListener(ev, function () { depot.classList.remove('is-survol'); }); });
    depot.addEventListener('drop', function (e) { e.preventDefault(); if (e.dataTransfer.files[0]) lireFichier(e.dataTransfer.files[0]); });
    $('[data-fond-btn]', sec).addEventListener('click', function () { etat.fond = !etat.fond; bornes(); rendre(); });
    caseMB.addEventListener('change', function () { etat.lasclay = !caseMB.checked; rendre(); });

    // --- outils d'aperçu
    var taille = $('[data-taille]', sec);
    taille.addEventListener('input', function () {
      var o = objet(); if (!o) return;
      etat.lw *= (taille.value / 100 * boite().w) / o.w; bornes(); planifier();
    });
    taille.addEventListener('change', function () { dessiner(false); memoriser(); });
    $$('[data-teinte] button', sec).forEach(function (b) {
      b.addEventListener('click', function () { etat.te = b.getAttribute('data-v'); rendre(); });
    });
    $('[data-suggere]', sec).addEventListener('click', function () { suggerer(); dessiner(); memoriser(); });

    /* ---------- aperçu photoréaliste (IA) ---------- */
    // L'aperçu calculé ici et le logo partent au service d'aperçu (proxy sur Render), qui vérifie le
    // jeton reCAPTCHA v3 auprès de Google avant d'appeler le modèle d'image. Le script de Google n'est
    // chargé qu'au premier clic : rien n'est chargé chez qui n'utilise pas la fonction.
    var boxIA = $('[data-ia]', sec), nbIA = 0, cleIA = '';
    function cleConfig() { return etat.p + '|' + etat.c; }
    if (boxIA && data.apercuIA && data.apercuIA.cle) {
      var btnIA = $('[data-ia-btn]', boxIA), statutIA = $('[data-ia-statut]', boxIA), resIA = $('[data-ia-resultat]', boxIA), imgIA = $('[data-ia-img]', boxIA);
      var dire = function (t) { statutIA.hidden = !t; statutIA.textContent = t || ''; };
      // Notre propre script, chargé une seule fois avec NOTRE clé : un reCAPTCHA déjà présent sur la page
      // (autre application) ne connaît pas cette clé.
      var chargerRC = function (cle) {
        if (!window.__lvRecaptcha) window.__lvRecaptcha = new Promise(function (ok, ko) {
          var sc = document.createElement('script');
          sc.src = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent(cle);
          sc.async = true; sc.onload = function () { window.grecaptcha ? ok() : ko(); }; sc.onerror = ko;
          document.head.appendChild(sc);
        });
        return window.__lvRecaptcha;
      };
      var recaptcha = function () {
        return new Promise(function (ok, ko) {
          var cle = data.apercuIA.cle, fini = false;
          var une = function (f) { return function (v) { if (!fini) { fini = true; f(v); } }; };
          ok = une(ok); ko = une(ko);
          // Clé refusée par Google, script bloqué, réseau coupé : on n'attend jamais indéfiniment.
          setTimeout(function () { ko({ code: 0 }); }, 15000);
          chargerRC(cle).then(function () {
            window.grecaptcha.ready(function () {
              try { window.grecaptcha.execute(cle, { action: 'apercu_ia' }).then(ok, ko); } catch (e) { ko({ code: 0 }); }
            });
          }, function () { ko({ code: 0 }); });
        });
      };
      // image réduite, en base64, pour l'envoi
      var enBase64 = function (source, max, type) {
        return new Promise(function (ok) {
          var w = source.width || source.naturalWidth, h = source.height || source.naturalHeight, k = Math.min(1, max / Math.max(w, h));
          var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k);
          var cx = c.getContext('2d');
          if (type === 'image/jpeg') { cx.fillStyle = '#fff'; cx.fillRect(0, 0, c.width, c.height); }
          cx.drawImage(source, 0, 0, c.width, c.height);
          c.toBlob(function (b) { if (!b) return ok(null); lireBase64(b).then(function (d) { ok({ type: type, base64: d }); }, function () { ok(null); }); }, type, 0.9);
        });
      };
      var maquetteIA = function () {
        return composer().then(function (b) {
          if (!b) return null;
          return new Promise(function (ok) { var i = new Image(); i.onload = function () { ok(i); URL.revokeObjectURL(i.src); }; i.onerror = function () { ok(null); }; i.src = URL.createObjectURL(b); });
        }).then(function (i) { return i ? enBase64(i, 1280, 'image/jpeg') : null; });
      };
      btnIA.addEventListener('click', function () {
        if (!objet()) return;
        if (nbIA >= 3) { dire(T.iaMax); return; }
        btnIA.disabled = true; dire(T.iaCours); toucher();
        var p = produit(), L = logoActif();
        Promise.all([recaptcha(), maquetteIA(), L ? enBase64(L.cv, 800, 'image/png') : null]).then(function (v) {
          if (!v[1]) throw { code: 0 };
          return fetch(data.apercuIA.url, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ jeton: v[0], maquette: v[1], logo: v[2], technique: etat.t, produit: p.titre, couleur: (p.couleurs[etat.c] || {}).nom || '', langue: en ? 'en' : 'fr' })
          });
        }).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || !j.image) throw { code: r.status }; return j; });
        }).then(function (j) {
          nbIA++; cleIA = cleConfig();
          imgIA.src = 'data:' + j.image.type + ';base64,' + j.image.base64;
          resIA.hidden = false; dire('');
        }).catch(function (e) {
          var c = e && e.code;
          dire(c === 429 ? T.iaLimite : c === 403 ? T.iaRobot : T.iaIndispo);
        }).then(function () { btnIA.disabled = false; });
      });
      $('[data-ia-fermer]', boxIA).addEventListener('click', function () { resIA.hidden = true; });
      $('[data-ia-telecharger]', boxIA).addEventListener('click', function () {
        var a = el('a', { href: imgIA.src, download: 'lasclay-apercu-ia-' + produit().handle + '.png' });
        document.body.appendChild(a); a.click(); a.remove();
      });
    } else boxIA = null;

    function memoriser() {
      var p = produit(), c = p.couleurs[etat.c] || {}, o = objet();
      partage.config = {
        produit: p.titre, handle: p.handle, url: p.url, couleur: c.nom || '', technique: etat.t ? data.techniques[etat.t][en ? 'en' : 'fr'] : '',
        quantite: etat.q, prixUnitaire: data.afficherPrix ? fmt(prixUnitaire()) : '', total: data.afficherPrix ? fmt(prixUnitaire() * etat.q) : '',
        remiseVolume: remiseDe(etat.q) ? remiseDe(etat.q) + ' %' : '',
        logoCouleur: etat.te, garderLasclay: etat.lasclay, marqueBlanche: !etat.lasclay,
        fondLogo: prepa && prepa.fondRetire ? (etat.fond ? 'conservé' : 'retiré') : '',
        // position sur la photo du produit, en % : centre, largeur de l'objet posé, rotation en degrés
        position: o ? { centreX: Math.round(etat.cx * 100), centreY: Math.round(etat.cy * 100), largeur: Math.round(o.w * 100), rotation: Math.round(etat.r), surPhoto: true } : null
      };
      partage.logo = logoFichier;
      // On ne garde pour la visite suivante que ce que le client a vraiment configuré.
      if (partage.touche) { try { var s = etatCourt(); s.touche = true; localStorage.setItem('lv-perso', JSON.stringify(s)); } catch (e) {} }
      publier();
    }
    function etatCourt() {
      return { v: 2, p: produit().handle, c: etat.c, t: etat.t, q: etat.q, lw: etat.lw === null ? null : +etat.lw.toFixed(4),
        cx: +etat.cx.toFixed(4), cy: +etat.cy.toFixed(4), r: Math.round(etat.r), te: etat.te, lasclay: etat.lasclay, fond: etat.fond };
    }

    // --- rendu complet
    function rendre() {
      var p = produit();
      if (etat.c >= p.couleurs.length) etat.c = 0;
      // couleurs
      var boxC = $('[data-couleurs]', sec); boxC.innerHTML = '';
      var etapeC = $('[data-etape-couleur]', sec);
      var aCouleurs = p.couleurs.length > 1 || (p.couleurs[0] && p.couleurs[0].nom);
      etapeC.hidden = !aCouleurs;
      p.couleurs.forEach(function (c, i) {
        var lab = el('label', { class: 'lvc-pastille', title: c.nom });
        var inp = el('input', { type: 'radio', name: 'lv-couleur-' + sec.id, value: i, 'aria-label': c.nom });
        inp.checked = i === etat.c;
        inp.addEventListener('change', function () { etat.c = i; rendre(); });
        var rond = el('span'); rond.style.background = hex[String(c.nom).toLowerCase()] || '#ccc';
        lab.appendChild(inp); lab.appendChild(rond); boxC.appendChild(lab);
      });
      $('[data-couleur-nom]', sec).textContent = p.couleurs[etat.c] ? p.couleurs[etat.c].nom : '';
      // techniques
      var boxT = $('[data-techniques]', sec); boxT.innerHTML = '';
      if (!etat.t || p.techniques.indexOf(etat.t) < 0) etat.t = p.techniques[0] || null;
      p.techniques.forEach(function (k) {
        var t = data.techniques[k]; if (!t) return;
        var lab = el('label', { class: 'lvc-option' });
        var inp = el('input', { type: 'radio', name: 'lv-tech-' + sec.id, value: k }); inp.checked = k === etat.t;
        inp.addEventListener('change', function () { etat.t = k; bornes(); rendre(); });
        lab.appendChild(inp);
        lab.appendChild(el('span', {}, t[en ? 'en' : 'fr'] + (data.afficherPrix && t.sup ? ' (+' + fmt(t.sup) + ')' : '')));
        boxT.appendChild(lab);
      });
      // photo (avec ou sans logo Lasclay), puis pose du logo
      if (boxIA && cleIA && cleIA !== cleConfig()) { $('[data-ia-resultat]', boxIA).hidden = true; cleIA = ''; }
      majPhoto();
      if (geometrie()) { if (etat.lw === null) suggerer(); bornes(); }
      // logo : fond retiré ou conservé, marque blanche
      blocFond.hidden = !(prepa && prepa.fondRetire && logoApercu);
      if (!blocFond.hidden) {
        $('[data-fond-texte]', sec).textContent = etat.fond ? T.fondGarde : T.fondRetire;
        $('[data-fond-btn]', sec).textContent = etat.fond ? T.retirerFond : T.garderFond;
      }
      caseMB.checked = !etat.lasclay;
      $('[data-mb-prix]', sec).textContent = data.afficherPrix && data.supMarqueBlanche ? ' (+' + fmt(data.supMarqueBlanche) + ')' : '';
      $$('[data-teinte] button', sec).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === etat.te ? 'true' : 'false'); });
      // quantités et prix
      $$('button', boxQ).forEach(function (b) { b.setAttribute('aria-pressed', parseInt(b.getAttribute('data-q'), 10) === etat.q ? 'true' : 'false'); });
      var alerte = $('[data-alerte-min]', sec);
      var minP = minimumDe(produit());
      alerte.hidden = etat.q >= minP; alerte.textContent = T.min.replace('{n}', minP);
      var boxPrix = $('[data-prix]', sec);
      boxPrix.hidden = !data.afficherPrix; $('[data-prix-note]', sec).hidden = !data.afficherPrix;
      if (data.afficherPrix) {
        var u = prixUnitaire();
        $('[data-prix-unitaire]', sec).textContent = fmt(u);
        $('[data-prix-total]', sec).textContent = fmt(u * etat.q);
      }
      // économie de volume : ce qu'elle donne maintenant, et ce que donnerait la quantité qui l'amène au maximum
      var vol = $('[data-volume]', sec), rMax = remiseMaximale(), qMax = qteMaximale(), rq = remiseDe(etat.q);
      vol.hidden = !data.afficherPrix || rMax <= 0;
      if (!vol.hidden) {
        var gab = function (t, o) { return t.replace('{r}', o.r).replace('{q}', o.q).replace('{p}', o.p || '').replace('{m}', o.m || ''); };
        $('[data-volume-actuel]', sec).textContent = rq > 0 ? gab(T.volume, { r: rq, m: fmt(prixAvant() - prixUnitaire()) }) : '';
        $('[data-volume-cible]', sec).textContent = rq >= rMax ? gab(T.volumeMax, { r: rMax, q: qMax })
          : (rq > 0 ? gab(T.volumeCible, { r: rMax, q: qMax, p: fmt(prixA(qMax)) }) : gab(T.volumeAucune, { r: rMax, q: qMax }));
      }
      dessiner();
      memoriser();
    }

    // --- image de l'aperçu (PNG, à la définition de la photo), pour téléchargement et pour la soumission
    function composer() {
      return new Promise(function (ok) {
        if (!img.complete || !img.naturalWidth) return ok(null);
        var W = img.naturalWidth, H = img.naturalHeight, cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var cx = cv.getContext('2d');
        cx.fillStyle = '#fff'; cx.fillRect(0, 0, W, H);
        try { cx.drawImage(img, 0, 0, W, H); } catch (e) { return ok(null); }
        if (logoApercu && objet()) {
          var lay = document.createElement('canvas'); lay.width = W; lay.height = H;
          try { peindre(lay.getContext('2d', { willReadFrequently: true }), W, H, false, {}); } catch (e) {}
          cx.globalCompositeOperation = etat.t === 'gravure' ? 'multiply' : 'source-over';
          cx.drawImage(lay, 0, 0);
        }
        try { cv.toBlob(function (b) { ok(b); }, 'image/png'); } catch (e) { ok(null); } // image non lisible (CORS) : pas d'aperçu
      });
    }
    partage.composer = composer;

    $('[data-telecharger]', sec).addEventListener('click', function () {
      composer().then(function (b) {
        if (!b) return;
        var a = el('a', { href: URL.createObjectURL(b), download: 'lasclay-apercu-' + produit().handle + '.png' });
        document.body.appendChild(a); a.click(); a.remove();
      });
    });
    $('[data-partager]', sec).addEventListener('click', function (e) {
      var url = location.href.split('#')[0] + '#' + sec.id + '?perso=' + encodeURIComponent(JSON.stringify(etatCourt()));
      var b = e.currentTarget, avant = b.textContent;
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
        b.textContent = T.copie; setTimeout(function () { b.textContent = avant; }, 1800);
      }).catch(function () { window.prompt('', url); });
    });
    $('[data-soumettre]', sec).addEventListener('click', function () {
      memoriser();
      composer().then(function (b) {
        partage.maquette = b; publier();
        var cible = document.querySelector(data.cibleSoumission || '#soumission');
        if (cible) { cible.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        else { location.href = '/pages/cadeaux-corporatifs' + (data.cibleSoumission || '#soumission'); }
      });
    });

    rendre();
  }

  /* ================================================================
     Formulaire de soumission
     ================================================================ */
  function lireBase64(blob) {
    return new Promise(function (ok, ko) {
      var r = new FileReader();
      r.onload = function () { ok(String(r.result).split(',')[1] || ''); };
      r.onerror = ko; r.readAsDataURL(blob);
    });
  }
  function initSoumission(form) {
    if (form.__lvSoum) return; form.__lvSoum = true;
    var envoi = form.getAttribute('data-envoi');
    var en = (document.documentElement.lang || '').slice(0, 2) === 'en';
    var resume = $('[data-resume]', form), resumeChamp = $('[data-resume-champ]', form), vignette = $('[data-maquette]', form);
    var champLogo = $('[data-logo-soumission]', form), boxLogo = $('[data-bloc-logo]', form), statut = $('[data-statut]', form);
    if (!envoi && boxLogo) boxLogo.hidden = true; // le formulaire de contact Shopify ne transporte pas de fichier

    function majResume(p) {
      var c = p.config; if (!c || !p.touche) return; // configurateur pas touché : rien à résumer
      var lignes = [
        (en ? 'Product: ' : 'Produit : ') + c.produit + (c.couleur ? ' · ' + c.couleur : ''),
        (en ? 'Technique: ' : 'Technique : ') + (c.technique || '–'),
        (en ? 'Quantity: ' : 'Quantité : ') + c.quantite + (c.prixUnitaire ? ' · ' + c.prixUnitaire + (en ? '/unit, about ' : '/u, environ ') + c.total : '') + (c.remiseVolume ? (en ? ' · volume discount ' : ' · remise de volume ') + c.remiseVolume : ''),
        (en ? 'Logo colour: ' : 'Couleur du logo : ') + c.logoCouleur + (c.fondLogo ? ' · ' + (en ? 'logo background ' + (c.fondLogo === 'retiré' ? 'removed' : 'kept') : 'fond du logo ' + c.fondLogo) : ''),
        c.garderLasclay ? (en ? 'Lasclay logo kept' : 'Logo Lasclay conservé') : (en ? 'White label: without the Lasclay logo' : 'Marque blanche : sans le logo Lasclay'),
        (en ? 'Logo file: ' : 'Fichier du logo : ') + (p.logo ? p.logo.name : (en ? 'none yet' : 'aucun pour le moment'))
      ];
      if (resume) { resume.hidden = false; $('[data-resume-texte]', resume).textContent = lignes.join('\n'); }
      if (resumeChamp) resumeChamp.value = lignes.join('\n');
      var q = $('[name="contact[Quantité]"]', form); if (q && !q.value) q.value = c.quantite;
      if (vignette && p.maquette) { vignette.hidden = false; vignette.src = URL.createObjectURL(p.maquette); }
    }
    partage.ecouteurs.push(majResume);
    if (partage.config && partage.touche) majResume(partage);

    if (!envoi) return; // envoi natif Shopify (courriel à la boutique)

    // Repli : envoi par le formulaire de contact Shopify, exactement comme un formulaire Shopify
    // ordinaire. requestSubmit() repasse par les écouteurs de Shopify (vérification hCaptcha, puis
    // envoi) ; __lvRepli laisse passer cet envoi-là dans notre propre écouteur.
    function envoyerParShopify() {
      form.__lvRepli = true;
      var parti = false;
      function partir(natif) {
        if (parti) return; parti = true;
        if (!natif && typeof form.requestSubmit === 'function') form.requestSubmit();
        else HTMLFormElement.prototype.submit.call(form);
      }
      var captcha = window.Shopify && window.Shopify.captcha;
      if (captcha && typeof captcha.protect === 'function' && !form.dataset.hcaptchaBound) {
        // hCaptcha pas encore branché sur ce formulaire : on le branche, puis on envoie.
        try { captcha.protect(form, function () { partir(false); }); setTimeout(function () { partir(true); }, 6000); return; } catch (err) {}
      }
      partir(false);
    }

    // En CAPTURE et avec stopImmediatePropagation : Shopify protège ses formulaires de contact par
    // un script qui écoute « submit » (sur le document, et sur le formulaire une fois hCaptcha
    // branché) et relance lui-même l'envoi natif. Sans cet arrêt, la demande part dans Missive ET
    // la page file vers la vérification hCaptcha de /challenge, puis vers un 2e courriel Shopify.
    form.addEventListener('submit', function (e) {
      if (form.__lvRepli) return; // repli en cours : on laisse faire Shopify
      e.preventDefault(); e.stopImmediatePropagation();
      if (form.querySelector('[name="contact[site]"]').value) return; // pot de miel
      var bouton = $('[type="submit"]', form); bouton.disabled = true;
      statut.hidden = false; statut.className = 'lvc-statut'; statut.textContent = en ? 'Sending…' : 'Envoi en cours…';
      var champs = {};
      $$('input, select, textarea', form).forEach(function (i) {
        var m = (i.name || '').match(/^contact\[(.+)\]$/); if (!m || i.type === 'file') return;
        if ((i.type === 'checkbox' || i.type === 'radio') && !i.checked) return;
        champs[m[1]] = champs[m[1]] ? champs[m[1]] + ', ' + i.value : i.value;
      });
      var logo = (champLogo && champLogo.files[0]) || partage.logo || null;
      if (logo && logo.size > LOGO_MAX) { statut.className = 'lvc-statut is-erreur'; statut.textContent = en ? 'Logo file too large (10 MB max).' : 'Fichier du logo trop lourd (10 Mo maximum).'; bouton.disabled = false; return; }
      Promise.all([logo ? lireBase64(logo) : null, partage.maquette ? lireBase64(partage.maquette) : null]).then(function (b64) {
        return fetch(envoi, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            champs: champs, configuration: partage.touche ? partage.config : null, langue: en ? 'en' : 'fr', page: location.href.split('#')[0],
            logo: logo ? { nom: logo.name, type: logo.type, base64: b64[0] } : null,
            maquette: b64[1] ? { nom: 'apercu.png', type: 'image/png', base64: b64[1] } : null
          })
        });
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        form.reset(); if (resume) resume.hidden = true; if (vignette) vignette.hidden = true;
        statut.className = 'lvc-statut is-ok';
        statut.textContent = en ? 'Thank you! Your request is in. We reply within two business days with a quote and a proof.' : 'Merci! Votre demande est bien reçue. Nous vous répondons d\'ici deux jours ouvrables avec une soumission et une épreuve.';
      }).then(function () { bouton.disabled = false; }, function () {
        // Le point de réception Missive ne répond pas (pas encore activé, en redéploiement, hors
        // ligne) : on envoie par le formulaire de contact Shopify pour ne jamais perdre la demande.
        // Le résumé du configurateur suit ; le logo non, et le courriel de repli est indiqué.
        if (champLogo) champLogo.disabled = true;
        var msg = $('[name="contact[body]"]', form), courriel = form.getAttribute('data-courriel') || '';
        if (msg && logo) msg.value += (msg.value ? '\n\n' : '') + (en ? '[Logo not transmitted: ' : '[Logo non transmis : ') + logo.name + (courriel ? (en ? ', to be sent to ' : ', à envoyer à ') + courriel : '') + ']';
        statut.className = 'lvc-statut'; statut.textContent = en ? 'Sending…' : 'Envoi en cours…';
        envoyerParShopify();
      });
    }, true);
  }

  function demarrer(root) {
    $$('[data-lv-perso]', root).forEach(initPerso);
    $$('[data-lv-soumission]', root).forEach(initSoumission);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { demarrer(document); }); else demarrer(document);
  document.addEventListener('shopify:section:load', function (e) { demarrer(e.target); });
})();
